<template>
  <el-main>
    <!-- data1 add btn -->
    <el-button type="primary" @click="data1.addForm1.dialogVisible = true"
      >+ 附件</el-button
    >
    <!-- 間隔 -->
    <br /><br />
    <!-- data1 table -->
    <el-table :data="data1.data" style="width: 100%">
      <el-table-column label="編號">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="附件">
        <template slot-scope="scope">
          <el-link :href="scope.row.attachmentFileUrl" target="_blank">{{
            scope.row.attachmentFileName
          }}</el-link>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button @click="data1UpdateForm1DialogOpen(scope.$index)"
            >編輯</el-button
          >
          <el-button @click="data1Delete(scope.$index)">刪除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- data1 add dialog -->
    <el-dialog
      title="新增"
      :visible.sync="data1.addForm1.dialogVisible"
      width="30%"
      @closed="data1AddForm1DialogClosed()"
      :close-on-click-modal="false"
    >
      <el-form
        :model="data1.addForm1.data"
        status-icon
        :rules="data1.addForm1.rules"
        ref="data1AddForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.addForm1.loading"
      >
        <el-form-item label="附件" prop="attachmentFile">
          <AttachmentFileUploader
            :fileQuantityLimit="1"
            :fileList.sync="data1.addForm1.data.attachmentFile"
          ></AttachmentFileUploader>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert
            v-show="data1.addForm1.errorMessage.length > 0"
            type="error"
            :closable="false"
            >{{ data1.addForm1.errorMessage }}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.addForm1.dialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" @click="data1AddForm1Submit()"
              >送出</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- data1 update dialog -->
    <el-dialog
      title="編輯"
      :visible.sync="data1.updateForm1.dialogVisible"
      width="30%"
      @closed="data1UpdateForm1DialogClosed()"
      :close-on-click-modal="false"
    >
      <el-form
        :model="data1.updateForm1.data"
        status-icon
        :rules="data1.updateForm1.rules"
        ref="data1UpdateForm1"
        label-width="100px"
        class="demo-ruleForm"
        v-loading.lock="data1.updateForm1.loading"
      >
        <el-form-item label="附件" prop="attachmentFile">
          <AttachmentFileUploader
            :fileQuantityLimit="1"
            :fileList.sync="data1.updateForm1.data.attachmentFile"
          ></AttachmentFileUploader>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert
            v-show="data1.updateForm1.errorMessage.length > 0"
            type="error"
            :closable="false"
            >{{ data1.updateForm1.errorMessage }}
          </el-alert>
        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.updateForm1.dialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" @click="data1UpdateForm1Submit()"
              >送出</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-main>
</template>

<script>
import {
  B_AboutUs_Background_AttachmentFile_Add,
  B_AboutUs_Background_AttachmentFile_GetList,
  B_AboutUs_Background_AttachmentFile_Update,
  B_AboutUs_Background_AttachmentFile_Delete,
} from '@/assets/js/api';
import AttachmentFileUploader from '@/components/AttachmentFileUploader.vue';

export default {
  data() {
    return {
      data1: {
        data: [],
        addForm1: {
          dialogVisible: false,
          loading: false,
          formRef: 'data1AddForm1',
          errorMessage: '',
          data: {
            attachmentFile: [],
          },
          rules: {
            attachmentFile: [{ required: true, message: '請上傳檔案' }],
          },
        },
        updateForm1: {
          updateId: 0,
          dialogVisible: false,
          loading: false,
          formRef: 'data1UpdateForm1',
          errorMessage: '',
          data: {
            attachmentFile: [],
          },
          rules: {
            attachmentFile: [{ required: true, message: '請上傳檔案' }],
          },
        },
      },
    };
  },
  components: {
    AttachmentFileUploader,
  },
  mounted() {
    this.data1GetList();
  },
  methods: {
    // data1 get list
    data1GetList() {
      B_AboutUs_Background_AttachmentFile_GetList()
        .then((res) => {
          this.data1.data = res.data.data;
        })
        .catch((err) => {
          this.$notify.error({
            title: '錯誤',
            message: err.response.data.message,
          });
        });
    },
    // data1 add
    data1AddForm1DialogClosed() {
      this.data1.addForm1.loading = false;
      this.$refs[this.data1.addForm1.formRef].resetFields();
      this.data1.addForm1.errorMessage = '';
    },
    data1AddForm1Submit() {
      this.$refs[this.data1.addForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.addForm1.loading = true;
          this.data1.addForm1.errorMessage = '';
          const fd = new FormData();
          fd.append(
            'attachmentFile',
            this.data1.addForm1.data.attachmentFile[0].raw,
          );
          B_AboutUs_Background_AttachmentFile_Add(fd)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
              });
              this.data1.addForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.addForm1.loading = false;
              this.data1.addForm1.errorMessage = err.response.data.message;
            });
        }
      });
    },
    // data1 update
    data1UpdateForm1DialogOpen(index) {
      const thisData = this.data1.data[index];
      this.data1.updateForm1.updateId = this.data1.data[index].id;
      this.data1.updateForm1.dialogVisible = true;
      this.data1.updateForm1.data.attachmentFile = [
        {
          name: thisData.attachmentFileName,
          url: thisData.attachmentFileUploaderUrl,
          originalFile: true,
        },
      ];
    },
    data1UpdateForm1DialogClosed() {
      this.data1.updateForm1.loading = false;
      this.$refs[this.data1.updateForm1.formRef].resetFields();
      this.data1.updateForm1.updateId = 0;
      this.data1.updateForm1.errorMessage = '';
    },
    data1UpdateForm1Submit() {
      this.$refs[this.data1.updateForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.updateForm1.errorMessage = '';
          this.data1.updateForm1.loading = true;
          const fd = new FormData();
          const checkAttachmentFile = this.data1.updateForm1.data.attachmentFile[0].originalFile !== true;
          // 因為只有單一檔案 沒更新不送後台
          if (checkAttachmentFile) {
            fd.append(
              'attachmentFile',
              this.data1.updateForm1.data.attachmentFile[0].raw,
            );
            B_AboutUs_Background_AttachmentFile_Update(
              this.data1.updateForm1.updateId,
              fd,
            )
              .then(() => {
                this.$notify({
                  title: '成功',
                  message: '修改成功',
                  type: 'success',
                });
                this.data1.updateForm1.dialogVisible = false;
                this.data1GetList();
              })
              .catch((err) => {
                this.data1.updateForm1.loading = false;
                this.data1.updateForm1.errorMessage = err.response.data.message;
              });
          } else {
            this.data1.updateForm1.dialogVisible = false;
          }
        }
      });
    },
    // data1 delete
    data1Delete(index) {
      this.$confirm('確定刪除?', '確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          B_AboutUs_Background_AttachmentFile_Delete(this.data1.data[index].id)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
              });
              this.data1GetList();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: 'warning',
              });
            });
        })
        .catch(() => {});
    },
  },
};
</script>
